import "core-js/modules/es.array.concat.js";
export var partner = {
  name: 'Expansión',
  consumer: 'expansion',
  features: ['iic'],
  productsFeatures: ['rating', 'rating-morningstar'],
  user: {
    actions: false
  },
  iic: {
    categoryProvider: 'MS',
    categoryProviders: ['MS'],
    getSheetPath: function getSheetPath(productType, product) {
      return "/".concat(productType.slug, "/").concat(product.alias, "-").concat(product.isin);
    },
    slugs: {
      fund: 'fondos-inversion',
      etf: 'etfs',
      plan: 'planes-pensiones',
      sicav: 'sicavs'
    }
  },
  headings: {
    title: 'h2'
  }
};